export const ACCOUNT_TYPES = {
  PROSPECT: 67728,
  SIGNED: 67731,
  PARTNER: 67732
};

export const HEALTH_SCORES = {
  GREEN: 677280000,
  YELLOW: 677280001,
  RED: 677280002,
  BLUE: 677280003,
  BLACK: 677280004,
  PURPLE: 677280005,
};

export const EMPLOYEE_RANGES = {
  R_1_49: 677280000,
  R_50_299: 677280001,
  R_300_499: 677280002,
  R_500_999: 677280003,
  R_1000_4999: 677280004,
  R_5000_PLUS: 677280005,
};
